import React from 'react'

import { ContentBlockText, ContentBlockTitle } from '../../components/ui/contentBlock'
import type { Market } from '../../lib/markets'

type Props = {
  market: Market
}

const CountryMarketFaqSection: React.FC<Props> = ({ market }) => {
  const { countryName } = market

  return (
    <details className='faq-section'>
      <summary className='faq-section__summary'>
        <ContentBlockTitle>Can I use TinyInvoice.app in {countryName}?</ContentBlockTitle>
      </summary>
      <div className='faq-section__body'>
        <ContentBlockText>
          Yes, TinyInvoice.app complies with the invoicing rules of {countryName}.
        </ContentBlockText>
      </div>
    </details>
  )
}

export default CountryMarketFaqSection
